import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// Import environment
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SpottradeService {

  constructor(private http: HttpClient) { }

  getAllPair = (params: any) => {
    return this.http.get(environment.spotApiUrl + 'api/admin/spotPair', { params })
  }

  getAllCurrency = () => {
    return this.http.get(environment.walletApiUrl + 'api/admin/getCurrency', {})
  }

  addPair = (data: any) => {
    return this.http.post(environment.spotApiUrl + 'api/admin/spotPair', data)
  }

  findById = (id: string) => {
    return this.http.get(environment.spotApiUrl + 'api/admin/find-id/' + id)
  }

  updatePair = (data: any) => {
    return this.http.put(environment.spotApiUrl + 'api/admin/spotPair', data)
  }

  getOrderHistory = (params: any) => {
    return this.http.get(environment.spotApiUrl + 'api/admin/spotOrderHistory', { params })
  }

  getOrderHistoryDoc = (params: any) => {
    return this.http.get(environment.spotApiUrl + 'api/admin/spotOrderHistory-doc', { params, responseType: 'text' as 'json' })
  }
 

  getTradeHistory = (params: any) => {
    return this.http.get(environment.spotApiUrl + 'api/admin/spotTradeHistory', { params })
  }

  getTradeHistoryDoc = (params: any) => {
    return this.http.get(environment.spotApiUrl + 'api/admin/spotTradeHistory-doc', { params, responseType: 'text' as 'json' })
  }

   getLocalFilledDublicateOrderHistory = (params: any) => {
    return this.http.get(environment.spotApiUrl + 'api/admin/get-local_dublicateFilled-doc', { params })
  }

   getMissingTradeHistory = (params: any) => {
    return this.http.get(environment.spotApiUrl + 'api/admin/get-missing-trade-history', { params })
  }
}
